import angular from 'angular'
import ctrl from './weekdays.ctrl'
import tpl from './index.html'
import './weekdays.css'

export default angular.module('weekdaysComponent', []).component('weekdays', {
  template: tpl,
  controller: ctrl,
  bindings: {
    days: '<'
  }
})
